"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeaheadInput = void 0;
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const react_1 = require("react");
const Styles = common_utils_1.labelStyles(__filename, {
    clearSelectionButton: {
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%',
    },
    instantLabelContainer(iconSize) {
        return {
            position: 'absolute',
            right: iconSize + 8,
            display: 'flex',
            alignItems: 'center',
        };
    },
});
const ClearSelectionButton = ({ clearSelection, isFocused, isHovered, }) => {
    const iconColor = !(isFocused || isHovered) ? 'grey500' : undefined;
    return (common_utils_1.isolateComponent("button", { css: Styles.clearSelectionButton, onClick: clearSelection, title: "Clear Selection" },
        common_utils_1.isolateComponent(design_system_1.Icon, { canAcceptPointerEvents: false, color: iconColor, name: "x", size: 20 })));
};
exports.TypeaheadInput = (props) => {
    const showClearSelectionButton = props.selectedItem && !props.isDisabled && props.isMenuOpen;
    return (common_utils_1.isolateComponent(design_system_1.TextInput, Object.assign({}, design_system_1.camelCaseAriaAttrs(props.getInputProps({
        ariaLabelledBy: props.ariaLabelledBy,
        autoComplete: props.autoComplete,
        onFocus: props.onFocus,
    })), { ariaLabel: props.ariaLabel, autoComplete: "off", canClickIconAfter: showClearSelectionButton, disabledText: props.disabledText, isDisabled: props.isDisabled, isErrored: props.isErrored, onChange: props.onChange, onClick: props.onFocus, placeholder: props.placeholder, renderIconAfter: ({ iconSize, isFocused, isHovered }) => (common_utils_1.isolateComponent(react_1.Fragment, null,
            props.selectedItem && props.selectedItem.instant && (common_utils_1.isolateComponent("div", { css: Styles.instantLabelContainer(iconSize) },
                common_utils_1.isolateComponent(design_system_1.TagLabel, { color: "dark", size: "small" }, "instant"))),
            showClearSelectionButton ? (common_utils_1.isolateComponent(ClearSelectionButton, { clearSelection: props.clearSelection, isFocused: isFocused, isHovered: isHovered })) : (props.iconEndName && (common_utils_1.isolateComponent(design_system_1.Icon, { name: props.iconEndName, size: iconSize }))))), size: props.size })));
};
exports.TypeaheadInput.defaultProps = {
    size: 'small',
};
